/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Arrival_DateInputs */

const en_cargo_arrival_date = /** @type {(inputs: Cargo_Arrival_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrival Date`)
};

const es_cargo_arrival_date = /** @type {(inputs: Cargo_Arrival_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de llegada`)
};

/**
* | output |
* | --- |
* | "Arrival Date" |
*
* @param {Cargo_Arrival_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_arrival_date = /** @type {((inputs?: Cargo_Arrival_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Arrival_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_arrival_date(inputs)
	return es_cargo_arrival_date(inputs)
});